<template>
   <div class="bg-light-grey flex min-h-screen flex-col items-center justify-center px-4 py-16">
      <div class="w-full max-w-xl">
         <!-- Header -->
         <div class="mb-10 text-center">
            <div class="mb-4 flex items-center justify-center gap-3">
               <img src="/assets/logo.png" alt="Domus Laetitiae" class="h-10 object-contain" />
               <span class="text-2xl font-normal tracking-widest">VILLA</span>
            </div>
            <p class="p-s text-grey italic">
               Vita, Integrazione, Legami, Lavoro, Accoglienza
            </p>
         </div>

         <!-- Description -->
         <div class="rounded-base border border-[var(--ui-border)] bg-white px-5 py-4">
            <p class="p-m text-grey leading-relaxed">
               Piattaforma gestionale centralizzata per coordinare ospiti, operatori e attività
               di tutte le strutture convenzionate della cooperativa.
            </p>
         </div>

         <!-- Features -->
         <div class="mt-5 grid grid-cols-2 gap-3">
            <div
               v-for="item in features"
               :key="item.label"
               class="rounded-base flex items-center gap-3 border border-[var(--ui-border)] bg-white px-4 py-3"
            >
               <UIcon :name="item.icon" class="text-grey size-4 shrink-0" />
               <span class="p-s">{{ item.label }}</span>
            </div>
         </div>

         <!-- CTA -->
         <div class="mt-8">
            <UButton to="/select-profile" size="lg" block>
               Accedi
            </UButton>
         </div>
      </div>
   </div>
</template>

<script lang="ts" setup>
definePageMeta({
   layout: false,
})

const features = [
   { icon: 'i-heroicons-users', label: 'Gestione ospiti' },
   { icon: 'i-heroicons-calendar', label: 'Calendario turni' },
   { icon: 'i-heroicons-book-open', label: 'Diario attività' },
   { icon: 'i-heroicons-building-office-2', label: 'Strutture' },
   { icon: 'i-heroicons-shield-check', label: 'Permessi RBAC' },
   { icon: 'i-heroicons-clipboard-document-list', label: 'Registro' },
   { icon: 'i-heroicons-exclamation-triangle', label: 'Incidenti' },
   { icon: 'i-heroicons-identification', label: 'Anagrafiche' },
]
</script>
